import React from 'react';
import { Link } from 'react-router-dom';

const StartupCTA = () => (
  <section data-testid="startup-cta" className="py-24 bg-[#00FF41]/5 border-y border-[#00FF41]/20">
    <div className="max-w-4xl mx-auto px-6 text-center">
      <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#00FF41] mb-4">Fase Startup</p>
      <h2 className="text-4xl md:text-5xl font-black tracking-tight mb-6">
        Aiutaci a partire
      </h2>
      <p className="text-xl text-zinc-400 mb-8 max-w-2xl mx-auto">
        Stiamo raccogliendo fondi per la fase iniziale. Con il tuo supporto, 
        AI_COVO diventerà realtà per tutta l'Italia.
      </p>
      <div className="flex flex-col sm:flex-row gap-4 justify-center">
        <Link to="/dona" className="btn-primary bg-[#00FF41] text-black border-[#00FF41] hover:bg-[#33FF66]">
          Dona Ora
        </Link>
        <Link to="/brand" className="btn-primary">
          Scarica Brand Kit
        </Link>
      </div>
    </div>
  </section>
);

export default StartupCTA;
